import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { MembersSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/members/')({
  validateSearch: zodValidator(MembersSearchSchema)
});